import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { revalidateOptions } from 'frontastic';

const useShippyProFormId = () => {
  const sdk = useSdk();
  const result = useSWR(
    `/action/shippypro/getShippyProFormId`,
    () => {
      return sdk.callAction<{ formId: string }>({
        actionName: 'shippypro/getShippyProFormId',
      });
    },
    revalidateOptions,
  );

  return result.data?.isError ? undefined : result.data?.data.formId;
};

export default useShippyProFormId;
